<template>
  <div>
    <el-form ref="user" :model="user"   label-width="50px"
             status-icon
             :rules="rules"
             label-position="left"

             class="demo-ruleForm login-page">
      <el-form-item label="" prop="username" >
        <el-input v-model="user.username" style="width: 70%;" >
          <template slot="prepend">用户名</template>
        </el-input>
      </el-form-item>
      <el-form-item label="测试文件上传">
        <el-upload ref="upfile"
                   action="#"
                   :auto-upload="false"
                   :on-change="handleChange"
                   :show-file-list="false"
                   :limit="1"
                   accept="image/png,image/gif,image/jpg,image/jpeg"
        >
          <img v-if="imgUrl" :src="imgUrl" width="180px" height="180px"/>
          <i v-else class="el-icon-plus" style="font-size: xxx-large;margin-top: 70px"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sendNow('register')" >上传</el-button>
        <span>已有帐号？去<router-link to="/enter/login">登录</router-link></span>
      </el-form-item>
    </el-form>

  </div>

</template>

<script>
export default {
  name: "ImageUploadTest",
  data(){
    return{
      user:{
        username: '',
      },
      fileList:[],
      imgUrl: '',
      rules:{

      }
    }
  },
  methods:{
    handleChange(file,fileList){
      const isLt2M = file.size / 1024 / 1024 < 2     //这里做文件大小限制
      if(!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        });
        this.$refs.upfile.clearFiles();
        return isLt2M
      }else {
        //多次上传
        this.$refs.upfile.clearFiles(); //上传成功之后清除历史记录

        this.fileList = fileList;
        console.log(file)
        //生成本地图片的url，直接src显示,删除或移动后url就失效了
        this.imgUrl = URL.createObjectURL(file.raw);

        console.log(this.imgUrl)
      }

    },

    sendNow(){
      var fd = new FormData()
      var face = this.fileList[0]
      fd.append('file',face.raw)
      fd.append('user',JSON.stringify(this.user))
      this.axios.post('/test/imageUpload',fd).then(res =>{
        if(res.data.code === 0) {
          this.$message(res.data.message)
          this.$message.success('图片上传成功');
        }else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>